export default __webpack_public_path__ + "static/media/clothes_1.18a63cda.mp4";